import { injectable } from 'inversify'

export type LogLevel = 'debug' | 'info' | 'warn' | 'error'
export type LogContext = Record<string, unknown>

/**
 * Wraps console.* (invariant 8: all browser APIs behind a gateway).
 *
 * Deliberately takes no constructor dependencies — code that must still be
 * able to log even if the DI container itself is broken (ErrorBoundaryComponent,
 * the global window error listener) can `new LoggingGateway()` directly
 * instead of going through injection. Everywhere else should get it via
 * Types.ILoggingGateway like any other gateway.
 */
@injectable()
export class LoggingGateway {
  debug(message: string, context?: LogContext): void {
    console.debug(message, context ?? '')
  }

  info(message: string, context?: LogContext): void {
    console.info(message, context ?? '')
  }

  warn(message: string, context?: LogContext): void {
    console.warn(message, context ?? '')
  }

  error(message: string, context?: LogContext): void {
    console.error(message, context ?? '')
  }
}
